module.exports = __webpack_public_path__ + "img/bg_1440.b847ad00.png";